/* Zero 1 — product page behaviour.
   Gallery thumbs, quantity stepper, variant picker, fitment accordion, and the
   "Goes well with" row, fetched from Shopify's recommendations route as a rendered section.
   Everything is null-safe: the page works with this file missing, and works with
   JavaScript off (the add-to-cart form posts to /cart/add on its own). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- gallery ---------- */
  function gallery() {
    var main = document.getElementById('z1-gal-img');
    var thumbs = document.querySelectorAll('[data-z1-thumb]');
    if (!main || !thumbs.length) return;
    Array.prototype.forEach.call(thumbs, function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        main.setAttribute('src', full);
        var ss = btn.getAttribute('data-srcset');
        if (ss) main.setAttribute('srcset', ss);
        Array.prototype.forEach.call(thumbs, function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  }

  /* ---------- quantity ---------- */
  function quantity() {
    var input = document.querySelector('[data-z1-qty-input]');
    if (!input) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-z1-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-z1-qty'), 10) || 0;
        var next = (parseInt(input.value, 10) || 1) + step;
        input.value = next < 1 ? 1 : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('change', function () {
      if ((parseInt(input.value, 10) || 0) < 1) input.value = 1;
    });
  }

  /* ---------- fitment accordion ---------- */
  function fitment() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-z1-fit-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-z1-fit]');
        if (!box) return;
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- variant picker ---------- */
  function variants() {
    var data = document.querySelector('[data-z1-variant-data]');
    var selects = document.querySelectorAll('[data-z1-opt]');
    var idField = document.querySelector('[data-z1-variant-id]');
    if (!data || !selects.length || !idField) return;

    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return; }
    if (!list || !list.length) return;

    var priceEl = document.querySelector('[data-z1-price]');
    var compareEl = document.querySelector('[data-z1-compare]');
    var saveEl = document.querySelector('[data-z1-save]');
    var stockEl = document.querySelector('[data-z1-stock]');
    var stockText = document.querySelector('[data-z1-stock-text]');
    var addBtn = document.querySelector('[data-z1-add]');
    var soldNote = document.querySelector('[data-z1-soldout]');

    function chosen() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function match(values) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i], ok = true;
        for (var j = 0; j < values.length; j++) {
          if (String(v.options[j]) !== String(values[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply() {
      var v = match(chosen());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (stockText) stockText.textContent = 'Not available';
        if (stockEl) stockEl.classList.add('is-out');
        return;
      }
      idField.value = v.id;
      if (priceEl) priceEl.textContent = v.price_html;
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = v.compare_html;
          compareEl.hidden = false;
          if (saveEl) {
            saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (stockText) stockText.textContent = v.available ? 'In stock' : 'Out of stock';
      if (stockEl) stockEl.classList.toggle('is-out', !v.available);
      if (soldNote) {
        if (!v.available && !soldNote.textContent.trim()) {
          soldNote.innerHTML = 'We build and restock these — <a href="/pages/contact">tell us your car</a> and we will come back with a price and a date.';
        }
        soldNote.hidden = v.available;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', apply); });
  }

  /* ---------- goes well with ----------
     Shopify only fills `recommendations` when the section is fetched from the recommendations
     route, so the page ships with the cross-sell pair only and we merge the recommended parts
     in front of them. intent=complementary is asked for first (a real "goes well with"); the
     store has none set yet, so it falls back to intent=related. Cards come back
     server-rendered, which keeps prices on the store's own money format. */
  function recommendations() {
    var box = document.querySelector('[data-z1-recs]');
    if (!box || !window.fetch || !window.DOMParser) return;
    var base = box.getAttribute('data-url');
    var grid = box.querySelector('[data-z1-rec-grid]') || box.querySelector('.z1-rec-grid');
    if (!base || !grid) return;
    var cap = parseInt(box.getAttribute('data-count'), 10) || 4;

    function hrefOf(card) {
      var a = card.querySelector ? card.querySelector('a[href]') : null;
      return a ? a.getAttribute('href').split('?')[0] : '';
    }

    var seen = {};
    seen[window.location.pathname] = true;
    var onPage = Array.prototype.slice.call(grid.children);
    onPage.forEach(function (c) {
      var h = hrefOf(c);
      if (h) seen[h] = true;
    });

    function pull(intent) {
      return fetch(base + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-z1-rec-grid]') || doc.querySelector('.z1-rec-grid');
          return fresh ? Array.prototype.slice.call(fresh.children) : [];
        })
        .catch(function () { return []; });
    }

    pull('complementary')
      .then(function (cards) { return cards.length ? cards : pull('related'); })
      .then(function (cards) {
        var room = cap - onPage.length;
        var ref = grid.firstChild;
        var added = 0;
        cards.forEach(function (card) {
          if (added >= room) return;
          var h = hrefOf(card);
          if (!h || seen[h]) return;
          seen[h] = true;
          grid.insertBefore(card, ref);
          added++;
        });
        if (grid.children.length) box.hidden = false;
      })
      .catch(function () { /* no recommendations: the cross-sell pair stands on its own */ });
  }

  ready(function () {
    gallery();
    quantity();
    fitment();
    variants();
    recommendations();
  });

  // Mobile sticky buy bar: show when the real Add to cart button is above the viewport; the bar submits the same form.
  ready(function () {
    var bar = document.querySelector('[data-z1-buybar]'); var form = document.querySelector('form.z1-atc[data-z1-atc]'); var mainBtn = form && form.querySelector('[data-z1-add]');
    if (!bar || !form || !mainBtn) return;
    var priceMain = document.querySelector('[data-z1-price]'); var priceBar = bar.querySelector('[data-z1-buybar-price]');
    // scroll-driven (an IntersectionObserver misses a jump from below-the-fold to above it)
    var upd = function () { var above = mainBtn.getBoundingClientRect().bottom < 0; bar.classList.toggle('is-on', above); bar.setAttribute('aria-hidden', above ? 'false' : 'true'); };
    var tick = false; var onS = function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; upd(); }); };
    window.addEventListener('scroll', onS, { passive: true }); window.addEventListener('resize', onS); upd();
    var btn = bar.querySelector('[data-z1-buybar-add]');
    if (btn) btn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click(); });
    if (priceMain && priceBar) new MutationObserver(function () { priceBar.textContent = priceMain.textContent; }).observe(priceMain, { childList: true, characterData: true, subtree: true });
  });
})();
